/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type consents_ParentRecordConsentRequest = {
    granted: boolean;
    scope: consents_ParentRecordConsentRequest.scope;
};
export namespace consents_ParentRecordConsentRequest {
    export enum scope {
        DOCUMENTATION = 'documentation',
        PHOTO_INTERNAL = 'photo_internal',
        PHOTO_PARENT_VISIBLE = 'photo_parent_visible',
        PRINTED_PORTFOLIO = 'printed_portfolio',
        EXTERNAL_SHARING = 'external_sharing',
    }
}

